<span>{{mapProjectionLabel}}</span>
